const FormResources = {
  form_data: {
    building_id: [],
    level_id: [],
    area_id: [],
    room_type_id: [],
    inspection_template_id: [],
    date_range: { startDate: "", endDate: "" },
  },

  form_data_2: {
    inspection_id: "",
    inspection_type_id: "",
    associate_id: "",
    associate_employee_id: "",
    inspection_template_id: "",
    date_range: {},
    needs_correction: "",
    building_id: "",
    level_id: "",
    area_id: "",
    floor_id: "",
    room: "",
    module_name: "",
  },

  form_format: [
    {
      css_class: "col-md-2",
      type: "infinite-scroll-list",
      maxlength: "",
      disabled: false,
      step: "",
      name: "Building:",
      model_name: "building_id",
      ref: "building_id_input",
      ref_alt: "building_id_input_alt",
      required: false,
      search: false,
      parent_class: "custom-control custom-checkbox w-100",
      input_type: "checkbox",
      input_class: "custom-control-input",
      label_input_class: "custom-control-label reports__show-hide__label ml-2",
      placeholder: "Select building(s)",
      close_on_option: false,
      track_by: "name",
    },
    {
      css_class: "col-md-2",
      type: "infinite-scroll-list",
      maxlength: "",
      disabled: false,
      step: "",
      name: "Level:",
      model_name: "level_id",
      ref: "level_id_input",
      ref_alt: "level_id_input_alt",
      required: false,
      search: false,
      parent_class: "custom-control custom-checkbox w-100",
      input_type: "checkbox",
      input_class: "custom-control-input",
      label_input_class: "custom-control-label reports__show-hide__label ml-2",
      placeholder: "Select level(s)",
      close_on_option: false,
      track_by: "name",
    },
    {
      css_class: "col-md-2",
      type: "infinite-scroll-list",
      maxlength: "",
      disabled: false,
      step: "",
      name: "Area:",
      model_name: "area_id",
      ref: "area_id_input",
      ref_alt: "area_id_input_alt",
      required: false,
      search: false,
      parent_class: "custom-control custom-checkbox w-100",
      input_type: "checkbox",
      input_class: "custom-control-input",
      label_input_class: "custom-control-label reports__show-hide__label ml-2",
      placeholder: "Select area(s)",
      close_on_option: false,
      track_by: "name",
    },
    {
      css_class: "col-md-2",
      type: "infinite-scroll-list",
      maxlength: "",
      disabled: false,
      step: "",
      name: "Room Type:",
      model_name: "room_type_id",
      ref: "room_type_id_input",
      ref_alt: "room_type_id_input_alt",
      required: false,
      search: false,
      parent_class: "custom-control custom-checkbox w-100",
      input_type: "checkbox",
      input_class: "custom-control-input",
      label_input_class: "custom-control-label reports__show-hide__label ml-2",
      placeholder: "Select room type(s)",
      close_on_option: false,
      track_by: "name",
    },
    {
      css_class: "col-md-2",
      type: "infinite-scroll-list",
      maxlength: "",
      disabled: false,
      step: "",
      name: "Inspection Template:",
      model_name: "inspection_template_id",
      ref: "inspection_template_id_input",
      ref_alt: "inspection_template_id_input_alt",
      required: false,
      search: false,
      parent_class: "custom-control custom-checkbox w-100",
      input_type: "checkbox",
      input_class: "custom-control-input",
      label_input_class: "custom-control-label reports__show-hide__label ml-2",
      placeholder: "Select inspection template(s)",
      close_on_option: false,
      track_by: "name",
    },
  ],

  form_format_2: [
    {
      css_class: "col-md-4",
      type: "select",
      maxlength: "",
      disabled: false,
      step: "",
      name: "Inspection:",
      model_name: "inspection_id",
      ref: "inspection_id_input",
      ref_alt: "inspection_id_input_alt",
      required: false,
      track_by: "title",
    },
  ],
  form_format_inspection_rooms_completion_by_area: [
    {
      css_class: "col-md-2",
      type: "checkbox",
      maxlength: "",
      disabled: false,
      step: "",
      name: "Sort by number of rooms completed:",
      model_name: "sort_out_by_rooms_completed",
      ref: "sort_out_by_rooms_completed_input",
      ref_alt: "sort_out_by_rooms_completed_input_alt",
    },
    {
      css_class: "col-md-2",
      type: "infinite-scroll-list",
      maxlength: "",
      disabled: false,
      step: "",
      name: "Building:",
      model_name: "building_id",
      ref: "building_id_input",
      ref_alt: "building_id_input_alt",
      required: false,
      search: false,
      parent_class: "custom-control custom-checkbox w-100",
      input_type: "checkbox",
      input_class: "custom-control-input",
      label_input_class: "custom-control-label reports__show-hide__label ml-2",
      placeholder: "Select building(s)",
      close_on_option: false,
      enable_check_all: true,
      track_by: "name",
    },
  ],
  form_format_inspection_items_grouped_by_template: [
    {
      css_class: "col-md-2",
      type: "infinite-scroll-list",
      maxlength: "",
      disabled: false,
      step: "",
      name: "Inspection Template:",
      model_name: "inspection_template_id",
      ref: "inspection_template_id_input",
      ref_alt: "inspection_template_id_input_alt",
      required: false,
      search: false,
      parent_class: "custom-control custom-checkbox w-100",
      input_type: "checkbox",
      input_class: "custom-control-input",
      label_input_class: "custom-control-label reports__show-hide__label ml-2",
      placeholder: "Select inspection template(s)",
      close_on_option: false,
      enable_check_all: true,
      track_by: "name",
    },
  ],
  form_data_supervisor_inspection_completion_by_template: {
    building_id: [],
    level_id: [],
    area_id: [],
    template_id: [],
    date_range: { startDate: "", endDate: "" },
  },

  form_format_supervisor_inspection_completion_by_template: [
    {
      css_class: "col-md-2",
      type: "infinite-scroll-list",
      maxlength: "",
      disabled: false,
      step: "",
      name: "Building:",
      model_name: "building_id",
      ref: "building_id_input",
      ref_alt: "building_id_input_alt",
      required: false,
      search: false,
      parent_class: "custom-control custom-checkbox w-100",
      input_type: "checkbox",
      input_class: "custom-control-input",
      label_input_class: "custom-control-label reports__show-hide__label ml-2",
      placeholder: "Select building(s)",
      close_on_option: false,
      enable_check_all: true,
      track_by: "name",
    },
    {
      css_class: "col-md-2",
      type: "infinite-scroll-list",
      maxlength: "",
      disabled: false,
      step: "",
      name: "Level:",
      model_name: "level_id",
      ref: "level_id_input",
      ref_alt: "level_id_input_alt",
      required: false,
      search: false,
      parent_class: "custom-control custom-checkbox w-100",
      input_type: "checkbox",
      input_class: "custom-control-input",
      label_input_class: "custom-control-label reports__show-hide__label ml-2",
      placeholder: "Select level(s)",
      close_on_option: false,
      enable_check_all: true,
      track_by: "name",
    },
    {
      css_class: "col-md-2",
      type: "infinite-scroll-list",
      maxlength: "",
      disabled: false,
      step: "",
      name: "Area:",
      model_name: "area_id",
      ref: "area_id_input",
      ref_alt: "area_id_input_alt",
      required: false,
      search: false,
      parent_class: "custom-control custom-checkbox w-100",
      input_type: "checkbox",
      input_class: "custom-control-input",
      label_input_class: "custom-control-label reports__show-hide__label ml-2",
      placeholder: "Select area(s)",
      close_on_option: false,
      enable_check_all: true,
      track_by: "name",
    },
    {
      css_class: "col-md-2",
      type: "infinite-scroll-list",
      maxlength: "",
      disabled: false,
      step: "",
      name: "Inspection Template:",
      model_name: "template_id",
      ref: "template_id_input",
      ref_alt: "template_id_input_alt",
      required: false,
      search: false,
      parent_class: "custom-control custom-checkbox w-100",
      input_type: "checkbox",
      input_class: "custom-control-input",
      label_input_class: "custom-control-label reports__show-hide__label ml-2",
      placeholder: "Select inspection template(s)",
      close_on_option: false,
      enable_check_all: true,
      track_by: "name",
    },
  ],
};

export default FormResources;
